<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Comments</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Updated By</th>
                    <th>Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(row, index) in list">
                    <td>{{ index + 1 }}</td>
                    <td v-if="row.status == 0"><span class="badge badge-light-warning badge-glow badge-sm">Deactive</span></td>
                    <td v-else-if="row.status == 1"><span class="badge badge-light-success badge-glow badge-sm">Active</span></td>
                    <td v-else-if="row.status == 2"><span class="badge badge-light-danger badge-glow badge-sm">Request For Changes</span></td>
                    <td v-else-if="row.status == 3"><span class="badge badge-light-info badge-glow badge-sm">Pending For Approval</span></td>
                    <td v-else ><span class="badge badge-light-secondary badge-glow badge-sm">Draft</span></td>
                    <td>{{ row.comments }}</td>
                    <td><span class="text-primary font-weight-bold font-small-3">{{ row.updated_by_user?.first_name + ' ' + row.updated_by_user?.last_name + ' (' + row.updated_by_user?.email + ')' }}</span></td>
                    <td>{{ new Date(row.created_at).toISOString().slice(0, 16).replace("T", " ") }}</td>
                  </tr>
                  <tr v-if="list.length == 0">
                    <td
                        colspan="11"
                        class="font-weight-bolder font-medium-2"
                        style="text-align: center"
                    >
                      <div class="spinner-border spinner-border-sm text-primary" v-show="loading" ></div>
                      No data avaliable
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "data", "index"],
  data() {
    return {
      list: [],
      loading: false,
      // showModal: false,
    };
  },
  methods:{

  },
  watch: {
    show(val) {
      this.list = []
      if(val){
        this.list =  this.data
      }
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

